const ENVIRONMENT = 'prod'; // dev or prod
const SERVER_URL_DEV = ''; // dev
const SERVER_URL_PROD = 'https://asa.safeaccessnow.org/widget'; // prod
export { ENVIRONMENT, SERVER_URL_DEV, SERVER_URL_PROD };
